import { createContext } from "react";
import type { UnitGroup } from "@/types";

export type PromoExpandedBy = "rent" | "reserve" | "quote" | null;

export interface UnitItemContextType {
    unitGroup: UnitGroup;
    selectedPromo: number;
    setSelectedPromo: (value: number) => void;
    promoExpandedBy: PromoExpandedBy;
    setPromoExpandedBy: (value: PromoExpandedBy) => void;
    promoExpandedPanelId: string;
}

export const UnitItemContext = createContext<UnitItemContextType | null>(null);
